'use strict';

var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var refType = PropTypes__default["default"].oneOfType([PropTypes__default["default"].func, PropTypes__default["default"].object]);
var refType$1 = refType;

module.exports = refType$1;
